import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Field, Control, Label, Input, Column } from "rbx";

import { Mutation } from "react-apollo";
import Section from "../../Section";
import {
  BooleanInput,
  PhoneNumberInput,
  StateSelect,
  SystemCodeSelect
} from "../../inputs";
import LocationParameterInputs from "./LocationParameterInputs";
import { CREATE_COMPANY_LOCATION_MUTATION } from "../../../graphql/Company/CompanyLocations.graphql";

class AddCompanyLocationForm extends Component {
  state = {
    CompanyId: "",
    LocationId: "",
    Name: "",
    DefaultLocation: false,
    Address1: "",
    Address2: "",
    City: "",
    State: "",
    ZipCode: "",
    Country: "",
    PhoneNo: "",
    FaxNo: "",
    Active: true,
    TimeZoneRecIdRef: "",
    DispatchTerminalFlag: false,
    InventoryLocationFlag: false,
    RevGLRecIdRef: "",
    ArGLRecIdRef: "",
    InvGLRecIdRef: "",
    CogsGLRecIdRef: "",
    ...this.props.companyLocation
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  render() {
    const {
      CompanyId,
      LocationId,
      Name,
      DefaultLocation,
      Address1,
      Address2,
      City,
      State,
      ZipCode,
      Country,
      PhoneNo,
      FaxNo,
      Active,
      TimeZoneRecIdRef,
      DispatchTerminalFlag,
      InventoryLocationFlag,
      RevGLRecIdRef,
      ArGLRecIdRef,
      InvGLRecIdRef,
      CogsGLRecIdRef
    } = this.state;
    const { onComplete, CompanyRecIdRef, codes } = this.props;
    const codeStates = {
      asset: codes.find(c => c.CodeId === "A"),
      expense: codes.find(c => c.CodeId === "E"),
      revenue: codes.find(c => c.CodeId === "R")
    };
    return (
      <Mutation
        mutation={CREATE_COMPANY_LOCATION_MUTATION}
        refetchQueries={["ALL_COMPANY_LOCATIONS_QUERY"]}
        variables={{
          data: {
            CompanyRecIdRef,
            CompanyId,
            LocationId,
            Name,
            DefaultLocation,
            Address1,
            Address2,
            City,
            State,
            ZipCode,
            Country,
            PhoneNo,
            FaxNo,
            Active,
            TimeZoneRecIdRef: parseInt(TimeZoneRecIdRef),
            DispatchTerminalFlag,
            InventoryLocationFlag,
            RevGLRecIdRef: parseInt(RevGLRecIdRef),
            ArGLRecIdRef: parseInt(ArGLRecIdRef),
            InvGLRecIdRef: parseInt(InvGLRecIdRef),
            CogsGLRecIdRef: parseInt(CogsGLRecIdRef)
          }
        }}
      >
        {(updateCompanyLocation, { loading, error }) => (
          <form
            id="edit-customer-contact"
            style={{ width: 800 }}
            onSubmit={async e => {
              e.preventDefault();
              await updateCompanyLocation();
              onComplete();
            }}
          >
            <Section title="Add Company Location">
              <Column.Group>
                <Column size={6}>
                  <Field kind="group">
                    <Control style={{ width: "30%" }}>
                      <Label>Location Id</Label>
                      <Input
                        autocomplete="new"
                        disabled={loading}
                        name="LocationId"
                        type="text"
                        value={LocationId}
                        onChange={this.onChange}
                      />
                    </Control>
                    <Control expanded>
                      <Label>Name</Label>
                      <Input
                        autocomplete="new"
                        disabled={loading}
                        name="Name"
                        type="text"
                        value={Name}
                        onChange={this.onChange}
                      />
                    </Control>
                  </Field>
                  <Field kind="group">
                    <Control expanded>
                      <Label>Address 1</Label>
                      <Input
                        autocomplete="new"
                        disabled={loading}
                        name="Address1"
                        type="text"
                        value={Address1}
                        onChange={this.onChange}
                      />
                    </Control>
                    <Control expanded>
                      <Label>Address 2</Label>
                      <Input
                        autocomplete="new"
                        disabled={loading}
                        name="Address2"
                        type="text"
                        value={Address2}
                        onChange={this.onChange}
                      />
                    </Control>
                  </Field>
                  <Field kind="group">
                    <Control expanded>
                      <SystemCodeSelect
                        disabled={loading}
                        icon="globe"
                        label="Time Zone"
                        lookup={{ Category: "Company", Code: "Time Zone" }}
                        name="TimeZoneRecIdRef"
                        size=""
                        value={TimeZoneRecIdRef}
                        onChange={this.onChange}
                      />
                    </Control>
                    <Control expanded>
                      <Label>Phone No</Label>
                      <PhoneNumberInput
                        disabled={loading}
                        name="PhoneNo"
                        value={PhoneNo}
                        onChange={this.onChange}
                      />
                    </Control>
                    <Control expanded>
                      <Label>Fax No</Label>
                      <PhoneNumberInput
                        disabled={loading}
                        name="FaxNo"
                        value={FaxNo}
                        onChange={this.onChange}
                      />
                    </Control>
                  </Field>
                </Column>
                <Column size={6}>
                  <Field kind="group">
                    <Control>
                      <Label>Default</Label>
                      <BooleanInput
                        disabled={loading}
                        name="DefaultLocation"
                        value={DefaultLocation}
                        onChange={this.onChange}
                      />
                    </Control>
                    <Control>
                      <Label>Active</Label>
                      <BooleanInput
                        disabled={loading}
                        name="Active"
                        value={Active}
                        onChange={this.onChange}
                      />
                    </Control>
                    <Control>
                      <Label>Dispatch Terminal</Label>
                      <BooleanInput
                        disabled={loading}
                        name="DispatchTerminalFlag"
                        value={DispatchTerminalFlag}
                        onChange={this.onChange}
                      />
                    </Control>
                    <Control>
                      <Label>Inventory Location</Label>
                      <BooleanInput
                        disabled={loading}
                        name="InventoryLocationFlag"
                        value={InventoryLocationFlag}
                        onChange={this.onChange}
                      />
                    </Control>
                  </Field>
                  <Field kind="group">
                    <Control expanded>
                      <Label>City</Label>
                      <Input
                        autocomplete="new"
                        disabled={loading}
                        name="City"
                        type="text"
                        value={City}
                        onChange={this.onChange}
                      />
                    </Control>
                    <Control>
                      <Label>State</Label>
                      <StateSelect
                        disabled={loading}
                        name="State"
                        size=""
                        value={State}
                        onChange={this.onChange}
                      />
                    </Control>
                    <Control expanded>
                      <Label>Zip Code</Label>
                      <Input
                        autocomplete="new"
                        disabled={loading}
                        name="ZipCode"
                        type="text"
                        value={ZipCode}
                        onChange={this.onChange}
                      />
                    </Control>
                    <Control expanded>
                      <Label>Country</Label>
                      <Input
                        autocomplete="new"
                        disabled={loading}
                        name="Country"
                        type="text"
                        value={Country}
                        onChange={this.onChange}
                      />
                    </Control>
                  </Field>
                </Column>
              </Column.Group>
              <Column.Group>
                <Column size={12}>
                  <LocationParameterInputs
                    ArGLRecIdRef={ArGLRecIdRef}
                    CogsGLRecIdRef={CogsGLRecIdRef}
                    InvGLRecIdRef={InvGLRecIdRef}
                    RevGLRecIdRef={RevGLRecIdRef}
                    codeStates={codeStates}
                    onChange={this.onChange}
                  />
                  <hr />
                </Column>
              </Column.Group>
              <Field kind="group">
                <Control>
                  <Button
                    color="success"
                    form="edit-customer-contact"
                    type="submit"
                  >
                    Submit
                  </Button>
                </Control>
                <Control>
                  <Button type="button" onClick={onComplete}>
                    Cancel
                  </Button>
                </Control>
              </Field>
            </Section>
          </form>
        )}
      </Mutation>
    );
  }
}

AddCompanyLocationForm.propTypes = {
  onComplete: PropTypes.func,
  CompanyRecIdRef: PropTypes.number.isRequired,
  companyLocation: PropTypes.object,
  codes: PropTypes.array
};
export default AddCompanyLocationForm;
